import { render, staticRenderFns } from "./WQDataLastRecordList.vue?vue&type=template&id=4a16c977&scoped=true"
import script from "./WQDataLastRecordList.vue?vue&type=script&lang=js"
export * from "./WQDataLastRecordList.vue?vue&type=script&lang=js"
import style0 from "./WQDataLastRecordList.vue?vue&type=style&index=0&id=4a16c977&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a16c977",
  null
  
)

export default component.exports